import { api } from '../createApi';
import { TagType } from '../TagType';

export const TURN_TRACKING_TAG = { type: TagType.TurnTracking, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.TurnTracking as TagType],
  endpoints: {
    getTurnTrackingParties: {
      providesTags: [TURN_TRACKING_TAG],
    },
  },
});
